export const BuildInfo = {timestamp:1779562856000}
